import { render, staticRenderFns } from "./footer.html?vue&type=template&id=75eae192&"
import script from "./footer.js?vue&type=script&lang=js&"
export * from "./footer.js?vue&type=script&lang=js&"
import style0 from "./footer.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports